import * as React from 'react';
import { Dispatch, ReactNode, createContext, useReducer } from 'react';

import { assertUnreachable } from '../../../../../util/assertUnreachable';

const InviteStudentsDrawerContext = createContext<boolean>(null);
const InviteStudentsDrawerDispatchContext =
  createContext<Dispatch<StudentDrawerAction>>(null);

export type StudentDrawerAction = 'Open' | 'Close';

function studentDrawerReducer(state: boolean, action: StudentDrawerAction) {
  switch (action) {
    case 'Close': {
      return false;
    }

    case 'Open': {
      return true;
    }

    default: {
      assertUnreachable(action);
    }
  }
}

interface Props {
  initialOpen?: boolean;
  children: ReactNode;
}
export function InviteStudentDrawerContext({
  initialOpen = false,
  children,
}: Props) {
  const [state, dispatch] = useReducer(studentDrawerReducer, initialOpen);

  return (
    <InviteStudentsDrawerContext.Provider value={state}>
      <InviteStudentsDrawerDispatchContext.Provider value={dispatch}>
        {children}
      </InviteStudentsDrawerDispatchContext.Provider>
    </InviteStudentsDrawerContext.Provider>
  );
}

export function useInviteStudentsDrawer() {
  const value = React.useContext(InviteStudentsDrawerContext);

  if (value === undefined) {
    throw new Error(
      'useInviteStudentsDrawer must be used within InviteStudentsDrawerContext'
    );
  }

  return value;
}

export function useInviteStudentsDrawerDispatch() {
  const value = React.useContext(InviteStudentsDrawerDispatchContext);

  if (value === undefined) {
    throw new Error(
      'useInviteStudentsDrawer must be used within InviteStudentsDrawerContext'
    );
  }

  return value;
}
